export const getters = {
  getOrgs: (state) => {
    return state.orgs
  },
  getSelected: (state) => {
    return state.selectedOrg
  },
  getSelectedOrg: (state) => {
    return state.orgs.find(o => o.organization_id === parseInt(state.selectedOrg))
  },
  getCurrent: (state) => {
    return state.current
  },
  getCurrentMembers: (state) => {
    return state.currentMembers
  },
  getCurrentInvites: (state) => {
    return state.currentInvites
  },
  getPendingInvites: (state) => {
    return state.pendingInvites
  },
  getCurrentProjectMembers: (state) => {
    return state.currentProjectMembers
  },
  getTotalMembersCount: (state) => {
    return state.currentMembers.length + state.currentProjectMembers.length
  },
  getApikeys: (state) => {
    return state.apikeys
  }
}
